<template>
    <div class="legal-sts">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">Legal Status</h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_legal_status_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            
            <!-- SAS View - Original Table -->
            <div v-if="_gAuth.isAppSas()">
                <div v-if="tableData.length > 0" class="rounded-bottom">
                    <el-table
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="legal_sts_loan_statue"
                            label="Facility"
                            min-width="180"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="top-line">{{ scope.row.legal_sts_current_outstanding | moneyFormatter }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="legal_sts_current_outstanding"
                            label="Outstanding (RM)"
                            min-width="200"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="top-line">{{ scope.row.legal_sts_current_outstanding | moneyFormatter }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="legal_sts_current_installment"
                            label="Instalment (RM)"
                            min-width="200"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="top-line">{{ scope.row.legal_sts_current_installment | moneyFormatter }}</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else class="bg-light p-3 text-center rounded-bottom">
                    <p class="text-xs">No Legal Status recorded</p>
                </div>
            </div>
            
            <!-- Non-SAS View -->
            <div v-else>
                <!-- For Non-SAS and Platform = CBM - Show Legal Cases Summary Table -->
                <div v-if="platform === 'CBM'">
                    <div v-if="normalizedLegalCasesSummary.length > 0" class="rounded-bottom">
                        <el-table
                        :data="normalizedLegalCasesSummary"
                        style="width: 100%">
                            <el-table-column
                                label="No."
                                min-width="80"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.$index + 1 }}.</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="case_type"
                                label="Case Type"
                                min-width="150"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.case_type || '-' }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="plaintiff"
                                label="Plaintiff"
                                min-width="150"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.plaintiff || '-' }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="latest_status"
                                label="Status"
                                min-width="150"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.latest_status || '-' }}</p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else class="bg-light p-3 text-center rounded-bottom">
                        <p class="text-xs">No Legal Cases recorded</p>
                    </div>
                </div>
                
                <!-- For Non-SAS and Platform = CTOS - Show SAS-style Table if data exists, otherwise fallback to CBM table -->
                <div v-else-if="platform === 'CTOS'">
                    <!-- Show SAS-style table if there's data in legalSts -->
                    <div v-if="tableData.length > 0" class="rounded-bottom">
                        <el-table
                        :data="tableData"
                        style="width: 100%">
                            <el-table-column
                                prop="legal_sts_loan_statue"
                                label="Facility"
                                min-width="180"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.legal_sts_loan_statue | moneyFormatter }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="legal_sts_current_outstanding"
                                label="Outstanding (RM)"
                                min-width="200"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.legal_sts_current_outstanding | moneyFormatter }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="legal_sts_current_installment"
                                label="Instalment (RM)"
                                min-width="200"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.legal_sts_current_installment | moneyFormatter }}</p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    
                    <!-- If no SAS-style data but there's Legal Cases Summary data, show CBM-style table -->
                    <div v-else-if="normalizedLegalCasesSummary.length > 0" class="rounded-bottom">
                        <el-table
                        :data="normalizedLegalCasesSummary"
                        style="width: 100%">
                            <el-table-column
                                label="No."
                                min-width="80"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.$index + 1 }}.</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="case_type"
                                label="Case Type"
                                min-width="150"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.case_type || '-' }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="plaintiff"
                                label="Plaintiff"
                                min-width="150"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.plaintiff || '-' }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="latest_status"
                                label="Status"
                                min-width="150"
                                width="auto">
                                <template slot-scope="scope">
                                    <p class="top-line">{{ scope.row.latest_status || '-' }}</p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    
                    <!-- If no data at all -->
                    <div v-else class="bg-light p-3 text-center rounded-bottom">
                        <p class="text-xs">No Legal Status recorded</p>
                    </div>
                </div>
                
                <!-- Fallback for other platforms -->
                <div v-else class="bg-light p-3 text-center rounded-bottom">
                    <p class="text-xs">No Legal Status recorded</p>
                </div>
            </div>
        </b-card>
        
        <LegalStatusModal
            :legal-sts="legalSts" 
            :legal-cases-summary="legalCasesSummary"
            :reserve-price="reservePrice"
            :legal-cases-resp="legalCasesResp"
            :show_legal_status_full_view.sync="modals.show_legal_status_full_view"
        />
    </div>
</template>

<script>
    import { Table, TableColumn } from 'element-ui'
    import LegalStatusModal from '@/views/CustomerProfile/CustomerModals/LegalStatusModal.vue'

    export default {
        name: 'legal-sts',
        props: [
            'legal-sts', 
            'reservePrice',
            'legalCasesSummary',
            'platform',
            'legalCasesResp'
        ],
        components: {
            LegalStatusModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.legalSts,
                modals: {
                  show_legal_status_full_view: false
                }
            }
        },
        computed: {
          normalizedLegalCasesSummary() {
            if (Array.isArray(this.legalCasesSummary)) {
              return this.legalCasesSummary;
            } else if (
              this.legalCasesSummary &&
              typeof this.legalCasesSummary === "object"
            ) {
              return [this.legalCasesSummary];
            }
            return [];
          },
        },
        methods: {
          formatCaseAmount(legalCase) {
            if (legalCase.amount && legalCase.amount > 0) {
              return `RM ${Number(legalCase.amount).toLocaleString(undefined, { 
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2 
              })}`;
            }
            
            if (legalCase.case_amt && legalCase.case_amt > 0) {
              return `RM ${Number(legalCase.case_amt).toLocaleString(undefined, { 
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2 
              })}`;
            }
            
            return '-';
          },
        }
    }
</script>